import * as React from "react"
import { MenuButton, MenuButtonProps } from "@reach/menu-button"
import { MdKeyboardArrowDown } from "react-icons/md"

export type DropdownButtonProps = MenuButtonProps

export function DropdownButton(props: DropdownButtonProps) {
  return <MenuButton {...props} />
}

export type DropdownMenuButtonStyledProps = DropdownButtonProps

export const DropdownMenuButtonStyled: React.FC<DropdownButtonProps> = ({
  children,
  ...props
}) => (
  <DropdownButton {...props}>
    {children}
    <MdKeyboardArrowDown />
  </DropdownButton>
)
